var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-icon',{style:(_vm.colorStyle?'color:'+_vm.colorStyle:''),attrs:{"data-test":_vm.dataTest,"icon":_vm.icon,"size":'is-'+_vm.size,"type":_vm.colorToShow}})
}
var staticRenderFns = []

export { render, staticRenderFns }